
import { RoleMaster } from "../actions/authUserActions";
import { RoleAction, RoleActionType } from "../actions/roleAction";

const initialState: RoleMaster[] = [];

const roleReducer = (
  state = initialState,
  action: RoleAction
): RoleMaster[] => {
  switch (action.type) {
    case RoleActionType.FETCH_ROLES:
      return action.data;

    case RoleActionType.ADD_ROLE:
      return [...state, action.data];

    case RoleActionType.EDIT_ROLE:
      return state.map((r) =>
        r.id === action.data.id ? action.data : r
      );

    case RoleActionType.DELETE_ROLE:
      return state.filter((r) => r.id !== action.data);

    default:
      return state;
  }
};

export default roleReducer;